import RefreshButton from '../../common/components/List/RefreshButton.js'
import {refreshStocktakeList} from './stocktakeListFunctions.js'

export default function RefreshStocktakeList() {
  return (
    <li
      className="inline-block margin-right-3 tooltip--top"
      data-hint="Refresh the Manufacturing Order list"
    >
      <RefreshButton onClick={() => refreshStocktakeList()} />
    </li>
  )
}
